import * as types from 'actionTypes/terms';
import * as utils from 'misc/utils';

// Search ======================================================================
const search = utils.createSearchAction(types.SEARCH);
export const searchRequest = search.requestFn;
export const searchSuccess = search.successFn;
export const searchFailure = search.failureFn;